import { createSlice } from "@reduxjs/toolkit";
import { formState } from "./data";
import clonedeep from "lodash.clonedeep";

const arrayNoIncludes = ["Image reference", "centre_0", "centre_20", "centre_40", "centre_60", "centre_80", "Latitude", "Longitude", "id_section", "Curvatura", "Inclinação", "Data de coleta de imagens em campo"]
const speedNumberTransform = (text => {
  return text.includes('km') ? Number(text.split('km')[0]) : Number(text.split('mph')[0]) * 1.60934
})

const handlerEqualsValidators = (state, payload, page) => {
  let segmentos = { ...state.segmentos };
  let validators = { ...state.validators };
  // const page = state.paginaAtual - 1;

  let speedLimit = null;
  let truckSpeedLimit = null;
  let speedDifferentialField = null;

  Object.keys(segmentos[page]).forEach((j) => {
    if (segmentos[page][j].title === "Limite de velocidade") {
      speedLimit = segmentos[page][j];
    }
    if (segmentos[page][j].title === "Limite de velocidade para caminhões") {
      truckSpeedLimit = segmentos[page][j];
    }
    if (segmentos[page][j].title === "Diferencial de velocidades") {
      speedDifferentialField = segmentos[page][j];
    }
  });

  if (speedLimit && truckSpeedLimit && speedDifferentialField) {
    const valueSpeed = speedLimit.selecionado.code ?
      speedNumberTransform(speedLimit.selecionado.title) : null;
    const valueTruck = truckSpeedLimit.selecionado.code ?
      speedNumberTransform(truckSpeedLimit.selecionado.title) : null;

    if (valueSpeed !== null && valueTruck !== null) {
      if (Math.abs(valueSpeed - valueTruck) <= 20) {
        validators[page].speedDifferential = false;
        speedDifferentialField.selecionado.code = 1;
        speedDifferentialField.selecionado.title = "Não presente";
      } else {
        validators[page].speedDifferential = true;
        speedDifferentialField.selecionado.code = 2;
        speedDifferentialField.selecionado.title = "Presente";
      }
    }
  }

  return [validators, segmentos];
};

const handlerShoulderValidators = (state, payload, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  let driverShoulder = null;
  let passengerShoulder = null;
  let soundEmitters = null;

  Object.keys(segmentos[page]).forEach((i) => {
    if (segmentos[page][i].title === "Largura do acostamento pavimentado - lado do condutor") {
      driverShoulder = segmentos[page][i].selecionado.code;
    }
    if (segmentos[page][i].title === "Largura do acostamento pavimentado - lado do passageiro") {
      passengerShoulder = segmentos[page][i].selecionado.code;
    }
    if (segmentos[page][i].title === "Sonorizadores ao longo do acostamento") {
      soundEmitters = segmentos[page][i];
    }
  });

  if (driverShoulder === 4 && passengerShoulder === 4) {
    validators[page].shoulderSoundEmitters = false;
    if (soundEmitters) {
      soundEmitters.selecionado.code = 1;
      soundEmitters.selecionado.title = "Não presente";
    }
  } else {
    validators[page].shoulderSoundEmitters = true;
  }

  return [validators, segmentos];
};

const handlerEducationalLandUseValidators = (state, payload, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  let driverSideLandUse = null;
  let passengerSideLandUse = null;

  Object.keys(segmentos[page]).forEach((i) => {
    if (segmentos[page][i].title === "Uso do solo - lado do condutor") {
      driverSideLandUse = segmentos[page][i].selecionado.code;
    }
    if (segmentos[page][i].title === "Uso do solo - lado do passageiro") {
      passengerSideLandUse = segmentos[page][i].selecionado.code;
    }
  });

  const noneIsEducational = driverSideLandUse !== 6 && passengerSideLandUse !== 6;

  if (noneIsEducational) {
    validators[page].educationalZone = true;

    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Advertência de zona escolar") {
        segmentos[page][i].selecionado.code = 4;
        segmentos[page][i].selecionado.title = "Não se aplica (nenhuma escola na localização)";
      }
      if (segmentos[page][i].title === "Supervisor de travessia em zona escolar") {
        segmentos[page][i].selecionado.code = 3;
        segmentos[page][i].selecionado.title = "Não se aplica (nenhuma escola na localização)";
      }
    });
  } else {
    validators[page].educationalZone = false;

    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Advertência de zona escolar" &&
        segmentos[page][i].selecionado.code === 4) {
        segmentos[page][i].selecionado.code = null;
        segmentos[page][i].selecionado.title = "";
      }
      if (segmentos[page][i].title === "Supervisor de travessia em zona escolar" &&
        segmentos[page][i].selecionado.code === 3) {
        segmentos[page][i].selecionado.code = null;
        segmentos[page][i].selecionado.title = "";
      }
    });
  }

  return [validators, segmentos];
};

const handlerVaridators = (state, item, codeSearch, arraySearch, validator, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };

  if (item.selecionado.code === codeSearch) {
    validators[page][validator] = true;
    Object.keys(segmentos[page]).forEach((i) => {
      arraySearch.forEach((fetchedItem) => {
        if (segmentos[page][i].title === fetchedItem.title) {
          segmentos[page][i].selecionado.code = fetchedItem.code;
          segmentos[page][i].selecionado.title = fetchedItem.text;
        }
      });
    });
  } else {
    validators[page][validator] = false;

    Object.keys(segmentos[page]).forEach((i) => {
      arraySearch.forEach((fetchedItem) => {
        if (segmentos[page][i].title === fetchedItem.title) {
          if (segmentos[page][i].selecionado.code === fetchedItem.code) {
            segmentos[page][i].selecionado.code = null;
            segmentos[page][i].selecionado.title = "";
          }
        }
      });
    });
  }

  return [validators, segmentos];
};

const handlerPedestrianValidators = (state, payload, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  let inspectionRoad = null;
  let crossroad = null;

  Object.keys(segmentos[page]).forEach((i) => {
    if (segmentos[page][i].title === "Infraestrutura para travessia de pedestres - na rodovia de inspeção") {
      inspectionRoad = segmentos[page][i].selecionado.code;
    }
    if (segmentos[page][i].title === "Infraestrutura para travessia de pedestres - na via transversal") {
      crossroad = segmentos[page][i].selecionado.code;
    }
  });

  if (inspectionRoad === 7 && crossroad === 7) {
    validators[page].pedestrianQuality = true;
    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Qualidade da travessia de pedestres") {
        segmentos[page][i].selecionado.code = 3;
        segmentos[page][i].selecionado.title = "Não se aplica";
      }
    });
  } else {
    validators[page].pedestrianQuality = false;

    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Qualidade da travessia de pedestres" &&
        segmentos[page][i].selecionado.code === 3) {
        segmentos[page][i].selecionado.code = null;
        segmentos[page][i].selecionado.title = "";
      }
    });
  }

  return [validators, segmentos];
};

const handlerDriverSideDistanceValidator = (state, payload, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  let driverSideDistance = null;

  Object.keys(segmentos[page]).forEach((i) => {
    if (segmentos[page][i].title === "Severidade lateral - distância do lado do condutor") {
      driverSideDistance = segmentos[page][i].selecionado.code;
    }
  });

  if (driverSideDistance === 1) {
    validators[page].driverShoulderWidth = true;
    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Largura do acostamento pavimentado - lado do condutor") {
        const currentSelection = segmentos[page][i].selecionado;
        if (currentSelection.code === 2 || currentSelection.code === 1) {
          segmentos[page][i].selecionado = { title: "", code: null };
        }
      }
    });
  } else {
    validators[page].driverShoulderWidth = false;
  }

  return [validators, segmentos];
};

const handlerPassengerSideDistanceValidator = (state, payload, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  let passengerSideDistance = null;

  Object.keys(segmentos[page]).forEach((i) => {
    if (segmentos[page][i].title === "Severidade lateral - distância do lado do passageiro") {
      passengerSideDistance = segmentos[page][i].selecionado.code;
    }
  });

  if (passengerSideDistance === 1) {
    validators[page].passengerShoulderWidth = true;
    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === "Largura do acostamento pavimentado - lado do passageiro") {
        const currentSelection = segmentos[page][i].selecionado;
        if (currentSelection.code === 2 || currentSelection.code === 1) {
          segmentos[page][i].selecionado = { title: "", code: null };
        }
      }
    });
  } else {
    validators[page].passengerShoulderWidth = false;
  }

  return [validators, segmentos];
};

const handlerObjectNoneDistance = (state, payload, side, page) => {
  let validators = { ...state.validators };
  let segmentos = { ...state.segmentos };
  // const page = state.paginaAtual - 1;

  const distanceTitle = side === 'driver'
    ? "Severidade lateral - distância do lado do condutor"
    : "Severidade lateral - distância do lado do passageiro";

  if (payload.selecionado.code === 17) { // "Nenhum objeto"
    // Forçar distância como ">10m" (código 4)
    Object.keys(segmentos[page]).forEach((i) => {
      if (segmentos[page][i].title === distanceTitle) {
        segmentos[page][i].selecionado.code = 4;
        segmentos[page][i].selecionado.title = ">10m";
      }
    });
    validators[page][side === 'driver' ? 'driverObjectNone' : 'passengerObjectNone'] = true;
  } else {
    validators[page][side === 'driver' ? 'driverObjectNone' : 'passengerObjectNone'] = false;
  }

  return [validators, segmentos];
};

const initialState = {
  segmentos: { 0: { ...clonedeep(formState) } },
  paginaAtual: 1,
  length: 0,
  isSave: false,
  hasChanged: false,
  imagens: [],
  validators: {
    0: {
      curveQuality: false,
      intersecion: true,
      speedDifferential: true,
      pedestrianQuality: true,
      shoulderSoundEmitters: true,
      educationalZone: false,
      driverShoulderWidth: false,
      passengerShoulderWidth: false,
      driverObjectNone: false,
      passengerObjectNone: false,
    },
  },
  duplicateImagesSectionId: [],
  savedStatus: [],
};

const reapplyFieldDependencies = (state, page) => {
  if (!state.segmentos[page]) return;

  Object.keys(state.segmentos[page]).forEach((k) => {
    const item = state.segmentos[page][k];

    if (item.title === "Curvatura") {
      handlerVaridators(
        state, item, 1,
        [{ title: "Qualidade da curva", code: 3, text: "Não se aplica" }],
        "curveQuality", page
      );
    }
    else if (item.title === "Tipo de interseção") {
      if (item.selecionado.code === 12) {
        state.validators[page].intersecion = true;
        Object.keys(state.segmentos[page]).forEach((k2) => {
          const it = state.segmentos[page][k2];
          if (it.title === "Qualidade da intersecção") { it.selecionado.code = 3; it.selecionado.title = "Não se aplica"; }
          if (it.title === "Canalização da intersecção") { it.selecionado.code = 1; it.selecionado.title = "Não presente"; }
          if (it.title === "Volume de tráfego na via transversal") { it.selecionado.code = 7; it.selecionado.title = "Não se aplica"; }
        });
      } else {
        state.validators[page].intersecion = false;
      }
    }
    else if (item.title === "Limite de velocidade" || item.title === "Limite de velocidade para caminhões") {
      const [nv, ns] = handlerEqualsValidators(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (
      item.title === "Infraestrutura para travessia de pedestres - na rodovia de inspeção" ||
      item.title === "Infraestrutura para travessia de pedestres - na via transversal"
    ) {
      const [nv, ns] = handlerPedestrianValidators(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (item.title === "Uso do solo - lado do condutor" || item.title === "Uso do solo - lado do passageiro") {
      const [nv, ns] = handlerEducationalLandUseValidators(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (
      item.title === "Largura do acostamento pavimentado - lado do condutor" ||
      item.title === "Largura do acostamento pavimentado - lado do passageiro"
    ) {
      const [nv, ns] = handlerShoulderValidators(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (item.title === "Severidade lateral - distância do lado do condutor") {
      const [nv, ns] = handlerDriverSideDistanceValidator(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (item.title === "Severidade lateral - distância do lado do passageiro") {
      const [nv, ns] = handlerPassengerSideDistanceValidator(state, item, page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (item.title === "Severidade lateral - objeto do lado do condutor") {
      const [nv, ns] = handlerObjectNoneDistance(state, item, "driver", page);
      state.validators = nv;
      state.segmentos = ns;
    }
    else if (item.title === "Severidade lateral - objeto do lado do passageiro") {
      const [nv, ns] = handlerObjectNoneDistance(state, item, "passenger", page);
      state.validators = nv;
      state.segmentos = ns;
    }
  });
};

export const dadosSegmentosSlice = createSlice({
  name: "dadosSegmentos",
  initialState,
  reducers: {
    setCurrentSegment: (state, { payload }) => {
      const page = state.paginaAtual - 1;
      Object.keys(state.segmentos[page]).forEach((i) => {
        if (state.segmentos[page][i].title === payload.title) {
          state.segmentos[page][i].selecionado = payload.selecionado;

          if (payload.title === "Limite de velocidade") {
            Object.keys(state.segmentos[page]).forEach((j) => {
              if (state.segmentos[page][j].title === "Limite de velocidade para motocicletas") {
                state.segmentos[page][j].selecionado = { ...payload.selecionado };
              }
            });
          }

          if (payload.title === "Curvatura") {
            handlerVaridators(
              state,
              payload,
              1,
              [{ title: "Qualidade da curva", code: 3, text: "Não se aplica" }],
              "curveQuality",
              page
            );
          } else if (payload.title === "Tipo de interseção") {
            handlerVaridators(
              state,
              payload,
              12,
              [
                { title: "Qualidade da intersecção", code: 3, text: "Não se aplica" },
                { title: "Canalização da intersecção", code: 1, text: "Não presente" },
                { title: "Volume de tráfego na via transversal", code: 7, text: "Não se aplica" },
              ],
              "intersecion",
              page
            );
          } else if (
            payload.title === "Limite de velocidade" ||
            payload.title === "Limite de velocidade para caminhões"
          ) {
            const [newValidators, newSegmentos] = handlerEqualsValidators(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (
            payload.title === "Infraestrutura para travessia de pedestres - na rodovia de inspeção" ||
            payload.title === "Infraestrutura para travessia de pedestres - na via transversal"
          ) {
            const [newValidators, newSegmentos] = handlerPedestrianValidators(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (
            payload.title === "Largura do acostamento pavimentado - lado do condutor" ||
            payload.title === "Largura do acostamento pavimentado - lado do passageiro"
          ) {
            const [newValidators, newSegmentos] = handlerShoulderValidators(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (
            payload.title === "Uso do solo - lado do condutor" ||
            payload.title === "Uso do solo - lado do passageiro"
          ) {
            const [newValidators, newSegmentos] = handlerEducationalLandUseValidators(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (payload.title === "Severidade lateral - distância do lado do condutor") {
            const [newValidators, newSegmentos] = handlerDriverSideDistanceValidator(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (payload.title === "Severidade lateral - distância do lado do passageiro") {
            const [newValidators, newSegmentos] = handlerPassengerSideDistanceValidator(state, payload, page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }
          else if (payload.title === "Severidade lateral - objeto do lado do condutor") {
            const [newValidators, newSegmentos] = handlerObjectNoneDistance(state, payload, 'driver', page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          } else if (payload.title === "Severidade lateral - objeto do lado do passageiro") {
            const [newValidators, newSegmentos] = handlerObjectNoneDistance(state, payload, 'passenger', page);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Marcar o segmento como não salvo ao alterar qualquer campo
          if (state.savedStatus && state.savedStatus.length > page) {
            state.savedStatus[page] = false;
          }
        }
      });
    },

    setSegmentSaved: (state, { payload }) => {
      const { index, saved } = payload;
      if (state.savedStatus.length <= index) {
        const newStatus = Array(index + 1).fill(false);
        state.savedStatus = newStatus.map((_, i) => state.savedStatus[i] ?? false);
      }
      state.savedStatus[index] = saved;
    },

    setAllSegmentsSaved: (state, { payload }) => {
      const { saved } = payload;
      state.savedStatus = Array(state.length).fill(saved);
    },

    applyBatchEdit: (state, { payload }) => {
      const { title, newValue, pages } = payload || {};
      if (!title || !newValue || !Array.isArray(pages) || pages.length === 0) return;

      pages.forEach((p) => {
        const idx = p - 1;
        if (idx < 0 || idx >= state.length) return;
        const segmento = state.segmentos[idx];
        if (!segmento) return;

        Object.keys(segmento).forEach((k) => {
          if (segmento[k].title === title) {
            segmento[k].selecionado = { ...newValue };
          }
        });

        if (state.savedStatus && state.savedStatus.length > idx) {
          state.savedStatus[idx] = false;
        }
      });
    },

    saveChange: (state, { payload }) => {
      const index = payload?.index ?? state.paginaAtual - 1;
      if (index >= 0 && index < state.length) {
        if (!state.savedStatus || state.savedStatus.length <= index) {
          const newStatus = Array(index + 1).fill(false);
          state.savedStatus = newStatus.map((_, i) => state.savedStatus[i] ?? false);
        }
        state.savedStatus[index] = true;
      }
      state.isSave = true;
    },

    setCurrentPage: (state, { payload }) => {
      state.paginaAtual = payload;
    },

    setArrayLength: (state, { payload }) => {
      let segmentos = { ...state.segmentos };
      let validators = { ...state.validators };
      for (let i = Object.keys(state.segmentos).length; i <= payload - 1; i++) {
        segmentos[i] = {};
        validators[i] = {
          curveQuality: false,
          intersecion: true,
          speedDifferential: true,
          pedestrianQuality: true,
          shoulderSoundEmitters: true,
          educationalZone: false,
          driverShoulderWidth: false,
          passengerShoulderWidth: false,
          driverObjectNone: false,
          passengerObjectNone: false,
        };
      }
      const newSavedStatus = Array(payload).fill(false);
      return {
        ...state,
        length: payload,
        segmentos: segmentos,
        validators: validators,
        savedStatus: newSavedStatus,
      };
    },

    setImageRef: (state, { payload }) => {
      for (let i = 0; i < state.length; i++) {
        Object.keys(state.segmentos[i]).forEach((item) => {
          if (state.segmentos[i][item].title === "Imagem de referência") {
            state.segmentos[i][item].label = payload.labels[0][i];
          }
        });
      }
    },

    setSegmento: (state, { payload }) => {
      return { ...state, paginaAtual: payload };
    },

    setAllSegments: (state, { payload }) => {
      const { segmentos, length, preservePage = false } = payload;

      state.segmentos = { ...segmentos };
      state.length = length;
      state.savedStatus = Array(length).fill(false);

      // Inicializa validators para todos os segmentos
      // for (let i = 0; i < length; i++) {
      //   state.validators[i] = {
      //     curveQuality: false,
      //     intersecion: true,
      //     speedDifferential: true,
      //     pedestrianQuality: true,
      //     driverShoulderWidth: false,
      //     passengerShoulderWidth: false,
      //   };
      // }

      for (let i = 0; i < length; i++) {
        state.validators[i] = {
          curveQuality: false,
          intersecion: true,
          speedDifferential: true,
          pedestrianQuality: true,
          shoulderSoundEmitters: true,
          educationalZone: false,
          driverShoulderWidth: false,
          passengerShoulderWidth: false,
          driverObjectNone: false,
          passengerObjectNone: false,
        };

        Object.keys(state.segmentos[i]).forEach((j) => {
          const item = state.segmentos[i][j];

          if (
            !preservePage &&
            item.title === "Etiqueta de pista" &&
            item.selecionado.code
          ) {
            state.paginaAtual = i + 1;
          }

          // Handler: Curvatura
          if (item.title === "Curvatura") {
            handlerVaridators(
              state,
              item,
              1,
              [{ title: "Qualidade da curva", code: 3, text: "Não se aplica" }],
              "curveQuality",
              i
            );
          }

          else if (item.title === "Tipo de interseção") {
            const page = i;
            if (item.selecionado.code === 12) {
              state.validators[page].intersecion = true;
              Object.keys(state.segmentos[page]).forEach((k) => {
                if (state.segmentos[page][k].title === "Qualidade da intersecção") {
                  state.segmentos[page][k].selecionado.code = 3;
                  state.segmentos[page][k].selecionado.title = "Não se aplica";
                }
                if (state.segmentos[page][k].title === "Canalização da intersecção") {
                  state.segmentos[page][k].selecionado.code = 1;
                  state.segmentos[page][k].selecionado.title = "Não presente";
                }
                if (state.segmentos[page][k].title === "Volume de tráfego na via transversal") {
                  state.segmentos[page][k].selecionado.code = 7;
                  state.segmentos[page][k].selecionado.title = "Não se aplica";
                }
              });
            } else {
              state.validators[page].intersecion = false;
            }
          }

          // Handler: Limites de velocidade
          else if (
            item.title === "Limite de velocidade para motocicletas" ||
            item.title === "Limite de velocidade para caminhões"
          ) {
            const [newValidators, newSegmentos] = handlerEqualsValidators(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Handler: Travessia de pedestres
          else if (
            item.title === "Infraestrutura para travessia de pedestres - na rodovia de inspeção" ||
            item.title === "Infraestrutura para travessia de pedestres - na via transversal"
          ) {
            const [newValidators, newSegmentos] = handlerPedestrianValidators(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Handler: Uso do solo
          else if (
            item.title === "Uso do solo - lado do condutor" ||
            item.title === "Uso do solo - lado do passageiro"
          ) {
            const [newValidators, newSegmentos] = handlerEducationalLandUseValidators(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Handler: Severidade lateral - lado do condutor
          if (item.title === "Severidade lateral - distância do lado do condutor") {
            const [newValidators, newSegmentos] = handlerDriverSideDistanceValidator(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Handler: Severidade lateral - lado do passageiro
          else if (item.title === "Severidade lateral - distância do lado do passageiro") {
            const [newValidators, newSegmentos] = handlerPassengerSideDistanceValidator(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }

          // Handler: Largura do acostamento
          if (
            item.title === "Largura do acostamento pavimentado - lado do condutor" ||
            item.title === "Largura do acostamento pavimentado - lado do passageiro"
          ) {
            const [newValidators, newSegmentos] = handlerShoulderValidators(state, item, i);
            state.validators = newValidators;
            state.segmentos = newSegmentos;
          }
        });
      }
    },
    setImagens: (state, { payload }) => {
      if (!payload.novoSegmento) {
        state.imagens = payload.imagens;
      } else {
        ["centre_0", "centre_20", "centre_40", "centre_60", "centre_80"].forEach(centre => {
          Object.keys(payload.segmento).forEach((varName) => {
            if (centre == varName) {
              state.imagens = [...state.imagens, payload.segmento[varName]];
            }
          });
        });
      }
    },

    setIdSection: (state, { payload }) => {
      Object.keys(state.segmentos[payload.index]).forEach((item) => {
        if (
          (state.segmentos[payload.index][item].title === "id_section" ||
            state.segmentos[payload.index][item].title === "latitude" ||
            state.segmentos[payload.index][item].title === "longitude") &&
          state.segmentos[payload.index][item].selecionado.code == undefined
        ) {
          state.segmentos[payload.index][item].selecionado.code =
            payload.item[state.segmentos[payload.index][item].title];
        }
      });
    },

    copySegmentPrevious: (state) => {
      const currentPage = state.paginaAtual - 1;
      const previousPage = state.paginaAtual - 2;
      if (previousPage < 0) return;

      Object.keys(state.segmentos[currentPage]).forEach(i => {
        if (!arrayNoIncludes.includes(state.segmentos[currentPage][i].title)) {
          Object.keys(state.segmentos[previousPage]).forEach(j => {
            if (state.segmentos[previousPage][i].title === state.segmentos[currentPage][j].title) {
              state.segmentos[currentPage][i].selecionado.code = state.segmentos[previousPage][j].selecionado.code;
              state.segmentos[currentPage][i].selecionado.title = state.segmentos[previousPage][j].selecionado.title;
            }
          });
          state.hasChanged = !state.hasChanged;
          state.validators[currentPage] = { ...state.validators[previousPage] };
        }
      });
      reapplyFieldDependencies(state, currentPage);
      if (state.savedStatus && state.savedStatus.length > currentPage) {
        state.savedStatus[currentPage] = false;
      }
    },

    copySegmentPreviousAndNext: (state) => {
      const currentPage = state.paginaAtual - 1;
      const nextPage = state.paginaAtual;
      if (nextPage >= state.length) return;

      Object.keys(state.segmentos[nextPage]).forEach(i => {
        if (!arrayNoIncludes.includes(state.segmentos[currentPage][i].title)) {
          Object.keys(state.segmentos[currentPage]).forEach(j => {
            if (state.segmentos[currentPage][i].title === state.segmentos[nextPage][j].title) {
              state.segmentos[nextPage][i].selecionado.code = state.segmentos[currentPage][j].selecionado.code;
              state.segmentos[nextPage][i].selecionado.title = state.segmentos[currentPage][j].selecionado.title;
            }
          });
          state.hasChanged = !state.hasChanged;
          state.validators[nextPage] = { ...state.validators[currentPage] };
        }
      });
      reapplyFieldDependencies(state, nextPage);
      if (state.savedStatus && state.savedStatus.length > nextPage) {
        state.savedStatus[nextPage] = false;
      }

      state.paginaAtual = nextPage + 1;
    },

    setDuplicateImagesId: (state, { payload }) => {
      state.duplicateImagesSectionId = payload;
    },

    reset: (state) => {
      return { ...initialState, segmentos: { 0: { ...clonedeep(formState) } } };
    },
  },
});

export const {
  setCurrentSegment,
  setArrayLength,
  setSegmento,
  setAllSegments,
  setIdSection,
  setImageRef,
  saveChange,
  copySegmentPrevious,
  copySegmentPreviousAndNext,
  setImagens,
  setDuplicateImagesId,
  reset,
  setCurrentPage,
  setSegmentSaved,
  setAllSegmentsSaved,
  applyBatchEdit
} = dadosSegmentosSlice.actions;

export default dadosSegmentosSlice.reducer;